import { registerRoute } from 'owa-router';
import { lazyMountAndShowDCSecondStep } from '../lazyFunctions';

export const DC_ROUTE_KEYWORD = 'domainconnect';
export const DC_STEP_KEYWORD = 'setalias';

function DomainConnectRouteHandler(parameters: any) {
    lazyMountAndShowDCSecondStep.importAndExecute();
}

export function initializeDomainConnectRoutes(appName: string, shouldRegisterWithAppName: boolean) {
    const routeValue = shouldRegisterWithAppName ? `/${appName}` : '';
    registerRoute(
        routeValue + `/${DC_ROUTE_KEYWORD}/${DC_STEP_KEYWORD}`,
        DomainConnectRouteHandler
    );
}
